import { render, staticRenderFns } from "./DemoPanel.vue?vue&type=template&id=e798d240&scoped=true&"
import script from "./DemoPanel.vue?vue&type=script&lang=js&"
export * from "./DemoPanel.vue?vue&type=script&lang=js&"
import style0 from "./DemoPanel.vue?vue&type=style&index=0&id=e798d240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e798d240",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VCol,VRow,VToolbarTitle})
